(() => {
  function init(scope=document) {
    scope.querySelectorAll('[data-cup-comparison]').forEach(root=>{
      if(root.dataset.ready)return;
      const data=JSON.parse(root.querySelector('[data-cup-data]').textContent);root.dataset.ready='true';
      root.querySelectorAll('[data-cup-select]').forEach(select=>select.addEventListener('change',()=>{
        const col=select.dataset.cupSelect,p=data[Number(select.value)];if(!p)return;
        const link=root.querySelector(`[data-cup-link="${col}"]`);link.href=p.href;
        const img=link.querySelector('img');
        const imageMap=root.querySelector('[data-cup-images]');img.src=imageMap?JSON.parse(imageMap.textContent)[p.image]:'/assets/'+p.image;
        img.removeAttribute('srcset');img.alt=p.title;
        root.querySelector(`[data-cup-title="${col}"]`).textContent=p.title;
        p.values.forEach((value,row)=>root.querySelector(`[data-cup-cell="${col}:${row}"]`).textContent=value);
        root.querySelector('[data-cup-status]').textContent=`Column ${Number(col)+1} now shows ${p.title}.`;
      }));
    });
    scope.querySelectorAll('.community-film-grid video').forEach(video=>video.addEventListener('play',()=>{
      document.querySelectorAll('.community-film-grid video').forEach(other=>{if(other!==video)other.pause();});
    }));
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();

(() => {
  const buttons=Array.from(document.querySelectorAll('[data-choice-filter]'));
  const groups=Array.from(document.querySelectorAll('[data-choice-group]'));
  if(!buttons.length||!groups.length)return;
  buttons.forEach(button=>button.addEventListener('click',()=>{
    const filter=button.dataset.choiceFilter;let count=0;
    buttons.forEach(other=>other.setAttribute('aria-pressed',String(other===button)));
    groups.forEach(group=>{
      const cards=Array.from(group.querySelectorAll('[data-choice-caffeine]'));
      cards.forEach(card=>{const caffeine=card.dataset.choiceCaffeine;card.hidden=!(filter==='all'||(filter==='tea'?caffeine!=='None':caffeine===filter));if(!card.hidden)count++;});
      group.hidden=cards.every(card=>card.hidden);
    });
    const status=document.querySelector('[data-choice-status]');if(status)status.textContent=`Showing ${count} teas.`;
  }));
})();
